import React, { useState, useContext, useEffect, useCallback } from 'react';
import AuthContext from '../context/AuthContext';

// Shown to the owner right after a walk completes. This is the screen that
// answers the pilot's core commercial question: does the owner rebook?
const ReviewAndRebook = () => {
  const { getToken } = useContext(AuthContext);
  const [walk, setWalk] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [rebooked, setRebooked] = useState(false);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');

  const fetchPending = useCallback(async () => {
    try {
      const response = await fetch('/api/walks/recent-completed-unreviewed', {
        headers: { 'Authorization': `Bearer ${getToken()}` }
      });
      const data = await response.json();
      setWalk(data);
    } catch (err) {
      console.error('Error fetching completed walk:', err);
    }
  }, [getToken]);

  useEffect(() => {
    fetchPending();
    const interval = setInterval(fetchPending, 5000);
    return () => clearInterval(interval);
  }, [fetchPending]);

  const submitReview = async () => {
    try {
      const response = await fetch('/api/reviews', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getToken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          walk_session_id: walk.id,
          reviewee_id: walk.walker_id,
          overall_rating: rating,
          comment
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    }
  };

  const rebook = async () => {
    try {
      const response = await fetch('/api/bookings', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getToken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          walker_id: walk.walker_id,
          dog_id: walk.dog_id,
          scheduled_start: new Date().toISOString(),
          scheduled_duration_minutes: walk.duration_minutes || 30,
          price_gbp: 12
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      setRebooked(true);
    } catch (err) {
      setError(err.message);
    }
  };

  if (!walk) return null;

  return (
    <div className="review-rebook-panel">
      <h3>How was {walk.walker_first_name}'s walk with {walk.dog_name}?</h3>
      {error && <p className="error">{error}</p>}

      {!submitted ? (
        <div className="review-form">
          <label>
            Rating:
            <select value={rating} onChange={(e) => setRating(parseInt(e.target.value))}>
              {[5, 4, 3, 2, 1].map(n => <option key={n} value={n}>{n} star{n > 1 ? 's' : ''}</option>)}
            </select>
          </label>
          <textarea
            placeholder="How did it go? (optional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <button onClick={submitReview}>Submit Review</button>
        </div>
      ) : !rebooked ? (
        <div className="rebook-prompt">
          <p>Thanks for the review!</p>
          <button className="confirm rebook-btn" onClick={rebook}>
            Book {walk.walker_first_name} again
          </button>
        </div>
      ) : (
        <p>✓ Booked {walk.walker_first_name} again — request sent.</p>
      )}
    </div>
  );
};

export default ReviewAndRebook;
